import { StoreCreateComponent } from './store-create.component';

export default StoreCreateComponent;
